import React from 'react';

const PolicyPage = () => {
  return <div>PolicyPage</div>;
};

export default PolicyPage;
